import { inject, Injectable } from '@angular/core';
import { LpAudioService } from '@features/lp/lp-audio/lp-audio.service';
import { LpParticlesService } from '@features/lp/lp-particles.service';
import { LpJuiceComposition, LpJuiceEffect, LpScreenPosition } from '@typings/lp/generated';

@Injectable({
  providedIn: 'root',
})
export class LpJuiceService {
  readonly #lpAudioService = inject(LpAudioService);
  readonly #lpParticlesService = inject(LpParticlesService);

  public async playComposition(juiceEffect: LpJuiceComposition, position: LpScreenPosition): Promise<void> {
    if (position.type !== 'MiddleOfScreen') throw new Error('Only MiddleOfScreen position is supported for now');

    await Promise.all([
      ...juiceEffect.audioEffects.map(
        async (audioEffect) => await this.#lpAudioService.play(audioEffect.audio, false, audioEffect.configuration),
      ),
      juiceEffect.juiceEffects.map(async (je) => await this.play(je)),
    ]);
  }

  public async play(juiceEffect: LpJuiceEffect): Promise<void> {
    if (juiceEffect.dataType === 'FireworksJuiceEffect') {
      await this.#lpParticlesService.playFireworks(juiceEffect.duration * 1000, juiceEffect.colors.split(','));
      return;
    }

    throw new Error(`Unsupported juice effect type: ${juiceEffect.dataType}`);
  }
}
